import { Component, OnInit } from '@angular/core';
import { Alert } from './alert';
import { AlertService } from './service/alert.service';

@Component({
    selector: 'app-alert',
    template: `
        <div class="alert-container" [ngStyle]="{'max-height.px': alerts.length > 0 ? height : 0}">
          @for (alert of alerts; track alert) {
            <div class="alert {{ alert.type }} alert-dismissable">
              <a class="close" (click)="removeAlert(alert)">&times;</a>
              <span class="message text-break">{{alert.message}}</span>
            </div>
          }
        </div>
        `,
    styleUrls: ['./alert.component.scss'],
    standalone: false
})

export class AlertComponent implements OnInit {
    alerts: Alert[] = [];
    height = 500;
    constructor(private alertService: AlertService) { }

    ngOnInit() {
        this.height = window.innerHeight - 140;
        this.alertService.getAlert().subscribe((alert: Alert) => {
            if (!alert) {
                // clear alerts when an empty alert is received
                this.alerts = [];
                return;
            }
            // add alert to array
            this.alerts.push(alert);
            if (alert.displayTime && alert.displayTime > 0) {
                setTimeout(() => {
                    this.removeAlert(alert);
                }, alert.displayTime);
            }
        });
    }

    removeAlert(alert: Alert) {
        this.alerts = this.alerts.filter(x => x !== alert);
    }
}
